import React, { ReactNode } from 'react';

import { StyledSubTitle, StyledTitleWrapper } from './styled';

type Props = {
  subTitle: string | ReactNode;
};
const StepHeader = ({ subTitle }: Props): JSX.Element => {
  return (
    <StyledTitleWrapper data-testid="stepHeaderWrapper">
      <StyledSubTitle data-testid="loginHeader">{subTitle}</StyledSubTitle>
    </StyledTitleWrapper>
  );
};

export default StepHeader;
